import cookie from 'js-cookie'
import auth from './auth'
import axios from 'axios'


export class Api {

    constructor(service, context) {
        this.service = service || 'employee'
        this.context = context
        this.axiosSetup()
    }

    getUrl(service) {
        return process.env.VUE_APP_PORTAL + '/api/' + service
    }

    axiosSetup() {
        var options = {
            baseURL: this.getUrl(this.service)
        };
        if (auth.loggedIn()) {
            options.headers = {
                'Authorization': 'Bearer ' + auth.getToken()
            }
        }

        let instance = axios.create(options)

        instance.interceptors.response.use((response) => {
            if (this.context) {
                this.context.$store.commit('setErrors', {})
            }
            return Promise.resolve(response);
        }, (error) => {
            if (this.context) {
                this.context.$root.handleError(error.response)
            }
            return Promise.reject(error);
        });

        this.axios = instance
    }

    post(endpoint, data) {
        return this.axios.post(endpoint, data)
    }

    delete(endpoint, data) {
        return this.axios.delete(endpoint, data)
    }

    get(endpoint, data) {
        data = data || null
        return new Promise((resolve, reject) => {
            this.axios.get(endpoint, data)
                .then(response => resolve(response))
                .catch(response => reject(response))
        })
    }

    fetchFromLocal(endpoint, request, resolve, reject) {
        let storageKey = this.service + ':' + endpoint + ':' + this.checksum(JSON.stringify(data))
        let data = localStorage.getItem(storageKey)
        if (data) {
            resolve(JSON.parse(data))
        } else {
            reject({})
        }
    }

    handleResponse(endpoint, data, response, resolve) {
        let storageKey = this.service + ':' + endpoint + ':' + this.checksum(JSON.stringify(data))
        localStorage.setItem(storageKey, JSON.stringify(response))
        resolve(response)
    }

    checksum(string) {
        let index;
        let checksum = 0x12345678;

        for (index = 0; index < string.length; index++) {
            checksum += (string.charCodeAt(index) * (index + 1));
        }

        return checksum;
    }

}

export function api(service, context) {
    return new Api(service, context);
};

export default {
    install(Vue, options) {
        Vue.prototype.$api = function (endpoint) {
            return new Api(endpoint, this);
        };
    }
}